module.exports = __webpack_public_path__ + "img/menu-bars.61d0352f.svg";